import ('./app'); // 异步执行应用入口
